import { theme } from "../../layout";

export const Cross = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.81454 11.7648L4.23535 11.1856L7.42087 8.00006L4.23535 4.81454L4.81454 4.23535L8.00006 7.42087L11.1856 4.23535L11.7648 4.81454L8.57924 8.00006L11.7648 11.1856L11.1856 11.7648L8.00006 8.57924L4.81454 11.7648Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
